import PropTypes from 'prop-types'

export default function LoadingDots({
  primaryColor = false,
  size = 'default',
}) {
  return (
    <div
      data-testid="loading-dots"
      className="tw-custom-loader tw-flex tw-justify-center tw-items-center">
      <span
        className={`tw-custom-dots-${size} tw-rounded-full ${
          primaryColor ? 'tw-bg-primary' : 'tw-bg-white'
        } tw-inline-block  tw-custom-dot`}></span>
      <span
        className={`tw-custom-dots-${size} tw-rounded-full ${
          primaryColor ? 'tw-bg-primary' : 'tw-bg-white'
        } tw-inline-block  tw-custom-dot tw-custom-delay-1`}></span>
      <span
        className={`tw-custom-dots-${size} tw-rounded-full ${
          primaryColor ? 'tw-bg-primary' : 'tw-bg-white'
        } tw-inline-block tw-custom-dot tw-custom-delay-2`}></span>
    </div>
  )
}

LoadingDots.propTypes = {
  primaryColor: PropTypes.bool,
  size: PropTypes.oneOf(['default', 'small']),
}
